import useDataTree from '@opsbase/web-ctrl-datatree/useDataTree';
import Columns from '@opsbase/web-layout/Columns';
import React from 'react';
import ViewReportKeyLine from './ViewReportKeyLine';
export function ViewReportKey(props) {
    const dt = useDataTree();
    const { groupBy, columns = 3, showCounts = false } = props;
    if (!groupBy)
        return null;
    const groups = dt.groupsForGroupBy.get(groupBy);
    return (React.createElement(Columns, { gutter: true, noOfCols: columns, style: { margin: 'auto', maxWidth: 700, padding: 20 } }, groups === null || groups === void 0 ? void 0 : groups.map(group => (React.createElement(ViewReportKeyLine, { key: group.id, group: group, showCounts: showCounts })))));
}
export default ViewReportKey;
